<template>
  <div v-if="$store.state.user.permissions.sms_show" class="smsservice">

    <div class="ui secondary pointing menu">
      <router-link to="/smsservice/0" class="item">Rund-SMS verschicken</router-link>
      <router-link to="/smsservice/1" class="item">{{menuDescAnmeldungen}}</router-link>
      <router-link to="/smsservice/2" class="item">Gesendet</router-link>
      <router-link to="/smsservice/3" class="item">Empfangen</router-link>
    </div> 

    <div v-show="$store.state.isLoading == false" class="wrapcontent">
      <div class="wrapsmssend" v-show="active == 0">

      <div class="sendsms">
        <textarea ref="smstextarea" class="smstextarea" cols="60" rows="15" autocomplete="off" v-model="smscontent">
        </textarea>
        <button tabindex="15" class="btn smssend" v-on:click="smssend">SMS versenden<div class="anzahlzeichen">{{anzahlzeichen}}</div></button>

        <div class="sms_preview" v-for="(sms, i) in smscontentarray" :key="i">
            <p>{{sms}}</p>
        </div>

        

        </div>  
        <sui-form>
        <sui-form-fields grouped>
          <sui-form-field class="first">
            <sui-checkbox
              label="An Alle"
              radio
              value="0"
              v-model="abteilung"
              :disabled="!$store.state.user.permissions.sms_send_all"
            />
          </sui-form-field>
          <sui-form-field>
            <sui-checkbox
              label="Abt. Fußball"
              radio
              value="fussball"
              v-model="abteilung"
              :disabled="!$store.state.user.permissions.sms_send_fussball"
            />
          </sui-form-field>
          <sui-form-field>
            <sui-checkbox
              label="Abt. Tennis"
              radio
              value="tennis"
              v-model="abteilung"
              :disabled="!$store.state.user.permissions.sms_send_tennis"
            />
          </sui-form-field>
          <sui-form-field>
            <sui-checkbox
              label="Abt. Volleyball"
              radio
              value="vollyball"
              v-model="abteilung"
              :disabled="!$store.state.user.permissions.sms_send_vollyball"
            />
          </sui-form-field>
          <sui-form-field>
            <sui-checkbox
              label="Abt. Gymnastik"
              radio
              value="gym"
              v-model="abteilung"
              :disabled="!$store.state.user.permissions.sms_send_gym"
            />
          </sui-form-field>
        </sui-form-fields>
      </sui-form>
      </div>

      <div v-show="active == 1">
        <BaseTable
        :settings="settings_anmeldungen" 
        :fields="fields_anmeldungen"
        :items="sms_anmeldungen"
        :searchTerm="$store.state.searchTerm"
        colstripes
        :bordered="false"
        tableClass="tableAnmeldungen"
        sortBy="start"
        sortOrder="desc"
        tableId="1" /> 
      </div> 

      <div v-show="active == 2">
        <BaseTable
        :settings="settings_gesendet" 
        :fields="fields_gesendet"
        :items="sms_gesendet"
        :searchTerm="$store.state.searchTerm"
        :bordered="false"
        colstripes
        tableClass="tableGesendet"
        sortBy="send_datetime"
        sortOrder="desc"
        tableId="2" />
      </div> 
      <div v-show="active == 3">
        <BaseTable
        :settings="settings_empfangen" 
        :fields="fields_empfangen"
        :items="sms_empfangen"
        :searchTerm="$store.state.searchTerm"
        :bordered="false"
        tableClass="tableEmpfangen"
        sortBy="receive_datetime"
        sortOrder="desc"
        tableId="3" /> 
      </div> 
    </div>
    
  </div>
</template>

<script>
import EventBus from "../bus";
import BaseTable from "../components/table/_BaseTable";
import functions from '../mixins/functions';
export default {
  name: 'smsservice',
  mixins: [functions],
  data () {
    return {
      anmeldungen_anzahl: 0,
      active: 0,
      abteilung: '-1',
      smscontent: '',
      smscontentarray: [],
      maxchars: 160,
      anzahlzeichen: '',
      sms_anmeldungen: [],
      settings_anmeldungen: {rowMax: 17},
      fields_anmeldungen: [
        { label: "Name", show: "name", classes: ["nowrap"], width: "200px"},
        { label: "Mobil", show: "number"},
        { label: "Aktiv", show: "active", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck"},
        { label: "Abt. Fußball", show: "fussball", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck"},
        { label: "Abt. Tennis", show: "tennis", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck"},
        { label: "Abt. Gymnastik", show: "gym", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck"},
        { label: "Abt. Volleyball", show: "vollyball", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck"},
        { label: "Von Mobil Rund-SMS", show: "send_news", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck"},
        { label: "Von Mobil an Alle", show: "send_all", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck"},
        { label: "Von Mobil an Abt. Fußball", show: "send_fussball", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck"},
        { label: "Von Mobil an Abt. Tennis", show: "send_tennis", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck"},
        { label: "Von Mobil an Abt. Gymnastik", show: "send_gym", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck"},
        { label: "Von Mobil an Abt. Volleyball", show: "send_vollyball", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck"},
        { label: "Start", show: "start", sort: "start_sort", width: "155px", type: "datetime", classes: ["center", "nowrap"], hclasses: ["center"]}
      ],
      sms_gesendet: [],
      settings_gesendet: {rowMax: 20},
      fields_gesendet: [
        { label: "Von", show: "von", classes: ["nowrap"], width: "150px"},
        { label: "Mobil", show: "number", width: "155px"},
        { label: "Web / Bot", show: "bot_web_desc", width: "50px", classes: ["center", "nowrap"], hclasses: ["nowrap"]},
        { label: "SMS Inhalt", show: "content", classes: ["nowrap", "ellipsis"]},
        { label: "Empfänger", show: "anzahl_empfaenger", title: "empfaenger", classes: ["center", "nowrap"], hclasses: ["nowrap"], width: "50px", type: "title"},
        { label: "An Alle", show: "all", classes: ["center", "nowrap", "icon"], hclasses: ["rotate"], width: "60px", type: "check"},
        { label: "An Abt. Fußball", show: "fussball", classes: ["center", "nowrap", "icon"], hclasses: ["rotate"], width: "60px", type: "check"},
        { label: "An Abt. Tennis", show: "tennis", classes: ["center", "nowrap", "icon"], hclasses: ["rotate"], width: "60px", type: "check"},
        { label: "An Abt. Gymnastik", show: "gym", classes: ["center", "nowrap", "icon"], hclasses: ["rotate"], width: "60px", type: "check"},
        { label: "An Abt. Volleyball", show: "vollyball", classes: ["center", "nowrap", "icon"], hclasses: ["rotate"], width: "60px", type: "check"},
        { label: "Gesendet", show: "send_datetime", sort: "send_datetime_sort", width: "155px", type: "datetime", classes: ["center", "nowrap"], hclasses: ["center"]}
      ],
      sms_empfangen: [],
      settings_empfangen: {rowMax: 20},
      fields_empfangen: [
        { label: "Von", show: "from_sms_service_id", classes: ["nowrap"], width: "150px"},
        { label: "Mobil", show: "number", width: "155px"},
        { label: "SMS Inhalt", show: "content", classes: ["nowrap", "ellipsis"], hclasses: ["nowrap"]},
        { label: "Empfangen", show: "receive_datetime", sort: "receive_datetime_sort", width: "155px", type: "datetime", classes: ["center", "nowrap"], hclasses: ["center"]}
      ],

      load: { anmeldungen: false, sms_send: false }
    }
  },
  created: function (){
    this.resetBar()
    this.initData()
  },
  mounted: function () {
    EventBus.$emit("checklogin")
    this.$store.state.heading = "SMS Service"
       
    this.$nextTick(() => this.$refs.smstextarea.select())

    EventBus.$on("refresh", (item, h) => {
      if(this.active == 1){
        this.refreshContent( 'sms_anmeldungen' )
      }
      else if(this.active == 2){
        this.refreshContent( 'sms_gesendet' )
      }
      else if(this.active == 3){
        this.refreshContent( 'sms_empfangen' )
      }
    });

    EventBus.$on("changeCheck", (item, h) => {

      if(h.show == "send_all" || h.show == "send_fussball" || h.show == "send_tennis" || h.show == "send_gym" || h.show == "send_vollyball"){
        var old_state = Object.assign({}, item)
        item.send_all = 2 
        item.send_fussball = 2 
        item.send_tennis = 2 
        item.send_gym = 2 
        item.send_vollyball = 2

        let headers = {'Content-Type': 'application/json'}
        this.$http.post('/api/sms.pl', {action: "setAnmeldungRadio", sms_service_id : item.sms_service_id, what: h.show, item: item}, {headers}).then(function (response) {
          var result = response.data
          if( result.status == 1 ){
            item.send_all = response.data.item.send_all 
            item.send_fussball = response.data.item.send_fussball
            item.send_tennis = response.data.item.send_tennis
            item.send_gym = response.data.item.send_gym
            item.send_vollyball = response.data.item.send_vollyball

            EventBus.$emit("checklogin")
          }
          else if( result.status == 2 ){
            item.send_all = old_state.send_all 
            item.send_fussball = old_state.send_fussball
            item.send_tennis = old_state.send_tennis
            item.send_gym = old_state.send_gym
            item.send_vollyball = old_state.send_vollyball
            EventBus.$emit("showinfo", "error", response.data.error, 10) 
          }
          else{
            item.send_all = old_state.send_all 
            item.send_fussball = old_state.send_fussball
            item.send_tennis = old_state.send_tennis
            item.send_gym = old_state.send_gym
            item.send_vollyball = old_state.send_vollyball
            EventBus.$emit("showinfo", "error", "Es ist ein Fehler aufgetreten", 10)        
          }
        });


      }
      else{
        var old_state = item[h.show]
        item[h.show] = 2;
        let headers = {'Content-Type': 'application/json'}
        this.$http.post('/api/sms.pl', {action: "setAnmeldung", sms_service_id : item.sms_service_id, what: h.show}, {headers}).then(function (response) {
          var result = response.data
          if( result.status == 1 ){
            item[h.show] = response.data.new_state 
            EventBus.$emit("checklogin")
          }
          else if( result.status == 2 ){
            item[h.show] = old_state
            EventBus.$emit("showinfo", "error", response.data.error, 10) 
          }
          else{
            item[h.show] = old_state
            EventBus.$emit("showinfo", "error", "Es ist ein Fehler aufgetreten", 10)        
          }
        });
      }

    });

    if(!this.$route.params.page_sms){
      this.$router.push({ name: 'smsservice', params: { page_sms: 0 } }).catch(err => {});
    }
    this.active = this.$route.params.page_sms
    this.$store.state.bar.search = (this.active == 0) ? false : true
    this.$store.state.bar.refresh = (this.active == 0) ? false : true
  },
  computed:{
    menuDescAnmeldungen(){
      return "Anmeldungen ( " + this.anmeldungen_anzahl + " )"
    }
  },
  methods: {
    smssend: function (event) {
      EventBus.$emit("hideinfo")

      if(this.abteilung == '-1'){
        EventBus.$emit("showinfo", "error", "An wen soll die SMS verschickt werden? Bitte eine Auswahl treffen!", 10) 
        return
      }
      console.log(this.smscontentarray.length)
      if(this.smscontentarray.length == 0 || (this.smscontentarray.length > 0 && this.smscontentarray[0].length <= 20 )){
        EventBus.$emit("showinfo", "info", "SMS muss mindestens 20 Zeichen haben", 10) 
        return
      }

      if( this.$store.state.user.permissions.sms_send_all ){
        let headers = { 'Content-Type': 'application/json'};
        console.log(document.cookie)
        this.$http.post(this.$store.state.user.send_sms_url,  { abteilung: this.abteilung, content: this.smscontentarray, c: document.cookie }, {headers, useCredentails: true}).then(function (response) {
          var result = response.data
          if( result.status == 0 ){
            EventBus.$emit("showinfo", "error", result.error, 10)  
          }
          else if( result.status == 2 ){
            EventBus.$emit("showinfo", "info", result.info, 5)   
          }
          else{
            EventBus.$emit("showinfo", "success", "SMS's wurden erfolgreich gesendet", 4)
            this.smscontent = "" 
          }
        }, response => {
            //error
             EventBus.$emit("showinfo", "error", "Es ist ein Fehler mit der Schnittstelle aufgetreten. Bitte den Webmaster kontaktieren.", 10)
          });

      }
      else{
        EventBus.$emit("showinfo", "error", "Keine Berechtigung SMS zu versenden", 10)
      }
    },
    // sms_anmeldungen_count(){
    //   this.$http.get('/api/getData.pl', {params:  {data: ['sms_anmeldungen_count']}}).then(function (response) {
    //     this.anmeldungen_anzahl = response.data.sms_anmeldungen_count
    //     this.$store.state.isLoading = false
    //   });
    // },
    get_all_data(){
      this.$http.get('/api/getData.pl', {params:  {data: ['sms_anmeldungen', 'sms_gesendet', 'sms_empfangen']}}).then(function (response) {
        this.sms_anmeldungen = response.data.sms_anmeldungen
        this.sms_gesendet = response.data.sms_gesendet
        this.sms_empfangen = response.data.sms_empfangen
        this.anmeldungen_anzahl = this.sms_anmeldungen.length
        this.load.anmeldungen = true
        this.load.sms_send = true
        this.checkLoadAll()
      });
    },
    initData(){
      this.$store.state.isLoading = true
      if(this.$store.state.user.permissions.sms_send_all){
        this.abteilung = '0'
      }
      else if(this.$store.state.user.permissions.sms_send_fussball){
        this.abteilung = '1'
      }
      else if(this.$store.state.user.permissions.sms_send_tennis){
        this.abteilung = '2'
      }
      else if(this.$store.state.user.permissions.sms_send_vollyball){
        this.abteilung = '3'
      }
      else if(this.$store.state.user.permissions.sms_send_gym){
        this.abteilung = '4'
      }
      this.get_all_data()
    },
    checkLoadAll(){
      if(this.load.anmeldungen && this.load.sms_send){
        this.$store.state.isLoading = false
      }
    },
    getSmsContent( content, maxchars ){

      if( content.length > maxchars ){

        // holt die erste x Zeichen aus dem string und split mit leerzeichen - array von Wörter zurück
        var textarray   = content.trim().substring(0, maxchars).split(" ")

        // nimmt alle wörter außer das letzte Wort und joint die leerzeichen wieder
        var smstext     = textarray.slice(0, -1).join(" ")

        // nimmt das letzte Wort aus dem Array
        var restsmstext = textarray.slice(textarray.length - 1, textarray.length ).join(" ")

        // das letzte Wort und der rest vom string wird zusammengeführt. Für die nächste Überprüfung
        var resttext    = restsmstext + content.trim().substring(maxchars, content.length )

        // push die SMS in content array
        this.smscontentarray.push(smstext)

        this.getSmsContent( resttext, maxchars )
      }
      else if( content.length > 0 ){
        var regex = /\w+/gm;
        var match = regex.exec(content)
        if( match ){
          this.smscontentarray.push(content)  
        }
      }
    },
    refreshContent( what ){
      this.$store.state.isLoading = true
      this.$http.get('/api/getData.pl', {params:  {data: [what]}}).then(function (response) {
        if( what == 'sms_anmeldungen' ){
          this.sms_anmeldungen = response.data.sms_anmeldungen
          this.anmeldungen_anzahl = this.sms_anmeldungen.length
        }
        else if( what == 'sms_gesendet' ){
          this.sms_gesendet = response.data.sms_gesendet
        }
        else if( what == 'sms_empfangen' ){
          this.sms_empfangen = response.data.sms_empfangen
        }
        this.$store.state.isLoading = false
      });
    }
  },
  watch:{
    smscontent(){
      this.smscontentarray = []
      var countchars = this.smscontent.length;
      var smscount = Math.floor( countchars / this.maxchars) + 1
      if( smscount > 1 ){
        this.anzahlzeichen = countchars + " (SMS: " + smscount + ")"  
      }
      else{
        this.anzahlzeichen = countchars
        this.smscontentarray.push(this.smscontent)
      }

      this.smscontentarray = []
      this.getSmsContent(this.smscontent, this.maxchars)
    },
    '$route' (to, from){
      if(!this.$route.params.page_sms){
        this.$router.push({ name: 'smsservice', params: { page_sms: 0 } }).catch(err => {});
      }
      this.active = this.$route.params.page_sms
      this.$store.state.bar.search = (this.active == 0) ? false : true
      this.$store.state.bar.refresh = (this.active == 0) ? false : true
      

    }
  },
  components: {
    BaseTable
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.ui.secondary.pointing.menu .router-link-active.item, .ui.secondary.pointing.menu .router-link-active.item:hover{
  color: #125171;
  border-color: #1F8CC4;
  font-weight: normal;
}
.wrapcontent .sendsms{
  display: flex;
  flex-direction: column;
  width: 400px;
}
.smssend{
  margin-top: 10px;
  position: relative;
}
.anzahlzeichen{
  position: absolute;
  right: 4px;
  bottom: 3px;
  font-size: 0.8rem;
}
.sms_preview{
  white-space: pre-wrap;
  width: 255px;
}
.sms_preview p{
  padding: 5px;
  display: inline-block;
}
.sms_preview :nth-child(1){
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  background-color: #dddddd;
  margin: 8px 0 0;
}
.smsservice .ui.menu{
  background: -moz-linear-gradient(left, rgba(252,252,252,1) 75%, rgba(255,255,255,0) 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(left, rgba(252,252,252,1) 75%,rgba(255,255,255,0) 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to right, rgba(252,252,252,1) 75%,rgba(255,255,255,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
}

.wrapsmssend{
  display: flex;
}
.wrapsmssend .ui.form{
  margin-left: 20px;
}
.ui.form .grouped.fields .field.first{
  margin-bottom: 14px;
}

</style>



// WEBPACK FOOTER //
// src/pages/SmsService.vue